import * as React from 'react';
import * as styles from "./ContentArea.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAEvent } from '../../event';
import { IAPhonebook } from '../../phonebook/Phonebook';
import { IAppPage } from '../../../interfaces/IAppPage';
import { IAppComponent } from '../../../interfaces/IAppComponent';
import { IABirthdays } from '../../birthdays/Birthdays';
import { LocalizationService } from '../../../services/LocalizationService';
// import { AddComponentButton } from '../../appAdmin/addComponentButton/AddComponentButton';
import { Helper } from '../../../Helper';
import { IANavigator } from '../../navigator';
import { IAContentMap } from '../../contentMap';
import { IAContentOrganizerPortal } from '../../contentOrganizerPortal';
import { MessagesContentArea } from './MessagesContentArea';
import { SharepointNews } from './SharepointNews';
import NativeService from '../../../services/NativeService';
import { AIAssistant } from '../../aiAssistant/AIAssistant';

export interface IContentAreaProps {
  store?: AppStore;
  selectedPageIndex: number;
  hasChanges: string;
  editMode?: boolean;
}

export interface IContentAreaState {
  messagesPadding: string;
}

@inject('store')
@observer
export class ContentArea extends React.Component<IContentAreaProps, IContentAreaState> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IContentAreaProps) {
    super(props);
    this.state = {
      messagesPadding: undefined
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    console.log("ContentArea didmount");
    const myDocument: any = document;
    if (myDocument.hasStorageAccess) {
      myDocument.hasStorageAccess().then(hasAccess => {
        if (!hasAccess) {
          return myDocument.requestStorageAccess();
        }
      }).then(() => {
        console.log("requestStorageAccess succeded")
      }).catch(() => {
        console.log("requestStorageAccess failed")
      });
    }
    this.componentWillReceiveProps();
  }

  private getSelectedCategories(selectedCategories: any[]): any[] {
    let categories = [];
    if (selectedCategories) {
      selectedCategories.forEach((categ) => {
        categories.push({
          checked: true,
          childNodes: [],
          columnName: categ.columnName,
          defaultLabel: categ.defaultLabel ? categ.defaultLabel : categ.name,
          name: categ.defaultLabel ? categ.defaultLabel : categ.name,
          expand: categ.expand,
          id: categ.id,
          labels: [],
          markedChild: categ.markedChild
        });
      });
    }
    return categories.sort((a, b) => a.defaultLabel - b.defaultLabel);
  }

  // private pageDoesNotContainEmbededPageOrExternalLinkOrPhonebookOrContentMap(): boolean {
  //   let pageDoesNotContainEmbededPageOrExternalLink = true;
  //   const page = this.props.store.instance.settings.menu[this.props.store.selectedPageIndex];
  //   if (page.components && page.components[0] && (page.components[0].type === "EmbeddedPage" || page.components[0].type === "ExternalLink" || page.components[0].type === "IntraActive-Phonebook" || page.components[0].type === "IntraActive-ContentOrganizer")) {
  //     pageDoesNotContainEmbededPageOrExternalLink = false;
  //   }
  //   return pageDoesNotContainEmbededPageOrExternalLink;
  // }

  public componentWillReceiveProps(props?: IContentAreaProps): void {
    if (props !== this.props) {
      this.forceUpdate();
    }
    if (props && this.props.selectedPageIndex !== props.selectedPageIndex) {
      this.props.store.selectedPageIndex = props.selectedPageIndex;
      console.log("Index: " + this.props.store.selectedPageIndex);
    }
    if (this.props.store.instance) {
      this.props.store.instance.settings.menu.forEach((page: IAppPage, index) => {
        //if (this.props.store.pages[this.props.store.selectedPageIndex] == undefined && this.props.store.selectedPageIndex === index) {
        if (this.props.store.selectedPageIndex === index) {
          this.props.store.pages[this.props.store.selectedPageIndex] = [];
          // if (this.props.store.editMode && this.props.store.selectedPageIndex != undefined && this.pageDoesNotContainEmbededPageOrExternalLinkOrPhonebookOrContentMap()) {
          //   this.props.store.pages[this.props.store.selectedPageIndex].push(
          //     <AddComponentButton
          //       key={`addComponentButton_${index}`}
          //       index={0}
          //     />
          //   );
          // }
          page.components.forEach((component: IAppComponent, index) => {
            switch (component.type) {
              case "EmbeddedPage":
                let embeddedUrl = component.url;
                if (window.platform === "ios" && !this.props.store.preview && embeddedUrl?.includes("apps.powerapps")) {
                  NativeService.showPowerApp(embeddedUrl);
                  this.props.store.showPowerApp = true;
                } else {
                  if (window.platform === "ios" && !this.props.store.preview) {
                    NativeService.hidePowerApp();
                    this.props.store.showPowerApp = false;
                  }
                  if (embeddedUrl && embeddedUrl.indexOf("sharepoint.com") != -1 && !component.showNavigator) {
                    if (embeddedUrl.indexOf("?") != -1) {
                      embeddedUrl = `${embeddedUrl}&hideNavigator=true`;
                    } else {
                      embeddedUrl = `${embeddedUrl}?hideNavigator=true`;
                    }
                  } else if (embeddedUrl && embeddedUrl.indexOf("sharepoint.com") != -1 && component.showNavigator && component.loadLinksExternally) {
                    if (embeddedUrl.indexOf("?") != -1) {
                      embeddedUrl = `${embeddedUrl}&loadLinksExternally=true" : ""}`;
                    } else {
                      embeddedUrl = `${embeddedUrl}?loadLinksExternally=true" : ""}`;
                    }
                  }
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    style={{
                      height: "100%",
                      width: "100%"
                    }}
                    key={`component_${index}`}
                  >
                    {(!(window.platform === "ios" && embeddedUrl?.includes("apps.powerapps")) || this.props.store.preview) &&
                      <iframe
                        src={embeddedUrl}
                        width="100%"
                        height="100%"
                      />
                    }
                  </div>
                );
                break;
              case "IntraActive-Messages":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                let selectedMessagesCategories: any = undefined;
                if (component.filterByCategory) {
                  selectedMessagesCategories = this.getSelectedCategories(component.categories)
                } else {
                  selectedMessagesCategories = [];
                }
                if (selectedMessagesCategories && component.instance) {
                  this.props.store.pages[this.props.store.selectedPageIndex].push(
                    <MessagesContentArea
                      pageIndex={this.props.store.selectedPageIndex}
                      componentIndex={index}
                      component={component}
                      selectedMessagesCategories={selectedMessagesCategories}
                    />
                  );
                }
                break;
              case "IntraActive-Events":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                let selectedEventCategories: any = undefined;
                if (component.filterByCategory) {
                  selectedEventCategories = this.getSelectedCategories(component.categories)
                } else {
                  selectedEventCategories = [];
                }
                if (selectedEventCategories && component.instance) {
                  this.props.store.pages[this.props.store.selectedPageIndex].push(
                    <div
                      style={{
                        padding: 25,
                      }}
                      key={`component_${index}`}
                    >
                      <IAEvent
                        environment={this.props.store.environment}
                        token={this.props.store.token}
                        tenant={this.props.store.tenant}
                        highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                        hasDarkBackground={Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.store.instance.settings.design.contentAreaColor, true, false)}
                        instance={component.instance}
                        isAdminPage={false}
                        rollupHighlightColor={component.higlightColor ?? (component.textColor ?? "#333333")}
                        isMobileApp
                        preview={this.props.store.preview}
                        panelIsOpen={(panelIsOpen: boolean) => {
                          this.props.store.blockReload = panelIsOpen;
                        }}
                        header={{
                          title: component.title,
                          headlineColor: '#333333',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        backgroundColor={component.backgroundColor}
                        textColor={component.textColor}
                        borderColor={component.borderColor}
                        borderRadius={component.borderRadius}
                        dateBadgeBackgroundColor={component.dateBadgeBackgroundColor}
                        dateBadgeTextColor={component.dateBadgeTextColor}
                        display={component.display}
                        numberOfCards={component.numberOfCards ? component.numberOfCards : 5}
                        showFilter={component.showFilter}
                        showPaging={true}
                        showPeriod={component.showPeriode ? component.showPeriode : "upcomming"}
                        showTitle={component.showCardTitle}
                        showImage={component.showImage}
                        showLikes={component.showLikes}
                        selectedCategories={selectedEventCategories}
                        showComments={component.showComments}
                        showCategories={component.showCategories}
                        showTimespand={component.showStartDate}
                        showLocation={component.showLocation}
                        addMessage={component.showAdd ? component.showAdd : false}
                        showDropShadow={component.showDropShadow}
                        shouldFilterByCategory={component.filterByCategory ? component.filterByCategory : false}
                        isTargetingAvailable={component.useTargeting ? component.useTargeting : false}
                        onlyShowIfThereIsContent={component.onlyShowIfThereIsContent}
                        textIfNoContent={component.noContentText}
                        webpartDisplayMode={this.props.store.editMode ? 2 : 1}
                      />
                    </div>
                  );
                }
                break;
              case "IntraActive-Phonebook":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <IAPhonebook
                    key={`component_${index}`}
                    environment={this.props.store.environment}
                    token={this.props.store.token}
                    tenant={this.props.store.tenant}
                    highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                    siteCollection={component.siteCollection}
                    showTitle={component.showTitle}
                    title={component.title}
                    titleColor={this.props.store.instance?.settings?.design?.contentAreaContentColor}
                    isMobile={true}
                    resultSourceId={component.searchResultId}
                  />
                );
                break;
              case "IntraActive-NavigatorAdmin":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    id="NavigatorContainerMobileApp"
                    key={`component_${index}`}
                    style={{ height: "100% " }}
                  >
                    {this.props.store.instance.settings.menu[this.props.store.selectedPageIndex]?.components[0].instance?.instanceName &&
                      <IANavigator
                        id="IA_Navigator"
                        environment={this.props.store.environment}
                        tenant={`${this.props.store.tenant}.sharepoint.com`}
                        token={this.props.store.token}
                        instance={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex]?.components[0].instance?.instanceName}
                        instanceId={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex]?.components[0].instance?.id}
                        isAdmin={false}
                        highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                        loadLinksExternally // ={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].loadLinksExternally}
                        asMobileAppComponent
                        isPreview={this.props.store.preview}
                      />
                    }
                  </div>
                );
                break;
              case "IntraActive-ContentOrganizer":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    key={`component_${index}`}
                    style={{
                      padding: 25,
                    }}
                  >
                    <IAContentMap
                      environment={this.props.store.environment}
                      isMobile
                      tenant={this.props.store.tenant}
                      token={this.props.store.token}
                      instance={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].instance}
                      highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                      styles={{}}
                      onClick={() => {
                      }}
                      hasDarkBackground={false}
                      openAllLinksExternally={true} // {this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].loadLinksExternally}
                      returnPageUrl={false}
                      showPage={(pageToShow: string) => {
                        this.props.store.contentMapPageToShow = pageToShow;
                      }}
                    />
                  </div>
                );
                break;
              case "IntraActive-ContentOrganizerPortal":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    key={`component_${index}`}
                    style={{
                      padding: 25,
                    }}
                  >
                    <IAContentOrganizerPortal
                      environment={this.props.store.environment}
                      tenant={this.props.store.tenant}
                      token={this.props.store.token}
                      instances={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].contentOrganizers}
                      searchPlaceholder={this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].placeholderText ? this.props.store.instance.settings.menu[this.props.store.selectedPageIndex].components[0].placeholderText : this.localizationService.strings.AppAdmin_ContentOrganizerSearch}
                      title={""}
                    />
                  </div>
                );
                break;
              case "IntraActive-AIAssistant":
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    style={{
                      padding: 25,
                      boxSizing: "border-box"
                    }}
                  >
                    <AIAssistant
                      environment={this.props.store.environment}
                      tenant={this.props.store.tenant}
                      highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                      contentLanguage={component.aiContentLanguage ?? "en"}
                      sites={component.aiSites}
                      title={component.title}
                      example={component.placeholderText}
                      infoHeadline={component.descriptionHeadline}
                      infoText={component.descriptionText}
                      infoIconUrl={component.descriptionIcon}
                    />
                  </div>
                );
                break;
              case "IntraActive-Birthday":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                let display: "CardView" | "ListView" = "CardView";
                if (component.display === "List view") {
                  display = "ListView";
                }
                let numbers: number[] = [];
                if (component.yearsAnniversary) {
                  Object.keys(component.yearsAnniversary).forEach(number => {
                    if (component.yearsAnniversary[number]) {
                      numbers.push(Number(number));
                    }
                  });
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <div
                    style={{
                      padding: 25,
                    }}
                    key={`component_${index}`}
                  >
                    <IABirthdays
                      environment={this.props.store.environment}
                      token={this.props.store.token}
                      tenant={`${this.props.store.tenant}.sharepoint.com`}
                      highlightColor={this.props.store.instance.settings.design.contentAreaHighlightColor}
                      properties={component.birthdayProperties}
                      display={display}
                      title={component.title}
                      type={component.birthdayType}
                      numDays={component.numberOfDays}
                      numberResults={component.numberOfCards}
                      years={numbers}
                      enableFilter={true}
                      filterOptions={{}}
                      emptyMessage={this.localizationService.strings.Messages_ViewPanel_NoMessages}
                      enablePaging={component.showPaging}
                      isMobile={true}
                      todayIcon={component.birthdayIcon}
                    />
                  </div>
                );
                break;
              case "Sharepoint-News":
                if (window.platform === "ios" && !this.props.store.preview) {
                  NativeService.hidePowerApp();
                  this.props.store.showPowerApp = false;
                }
                this.props.store.pages[this.props.store.selectedPageIndex].push(
                  <SharepointNews
                    pageIndex={this.props.store.selectedPageIndex}
                    componentIndex={index}
                    component={component}
                  />
                );
                break;
              default:
                break;
            }
            // if (this.props.store.editMode && this.props.store.selectedPageIndex != undefined && this.pageDoesNotContainEmbededPageOrExternalLinkOrPhonebookOrContentMap()) {
            //   this.props.store.pages[this.props.store.selectedPageIndex].push(
            //     <AddComponentButton
            //       key={`addComponentButton_${index + 1}`}
            //       index={index + 1}
            //     />
            //   );
            // }
          });
        }
      });
    }
  }

  public render(): JSX.Element {
    console.log("this.props.store.selectedPageIndex: " + this.props.store.selectedPageIndex);
    let height = this.props.store.instance.settings.design.menuStyle === "TabBar" && (this.props.store.instance.settings.menu.length > 1 || this.props.store.editMode) ? `calc(100vh - ${window.platform === "android" ? 100 : this.props.store.isIPhoneXType ? 160 : 120}px)` : `calc(100vh - ${window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70}px)`;
    if (this.props.store.preview) {
      height = this.props.store.instance.settings.design.menuStyle === "TabBar" && (this.props.store.instance.settings.menu.length > 1 || this.props.store.editMode) ? "600px" : "650px";
    }
    const pages = [];
    if (this.props.store.pages) {
      this.props.store.pages.forEach((page: JSX.Element[], index) => {
        pages.push(
          <div
            style={{
              opacity: this.props.store.selectedPageIndex === index ? 1 : 0,
              userSelect: this.props.store.selectedPageIndex === index ? "auto" : "none",
              width: this.props.store.selectedPageIndex === index ? "100%" : 0,
              position: 'absolute',
              overflow: this.props.store.selectedPageIndex === index ? "unset" : "hidden",
              height: "100%"
            }}
            key={`page_${index}`}
          >
            {page}
          </div>
        );
      });
    }
    return (
      <div
        className={styles.IA_contentArea}
        id="IA_contentArea"
        style={{
          backgroundColor: this.props.store.instance.settings.design.contentAreaColor,
          height: height,
          top: window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70
        }}
      >
        {pages}
      </div >
    );
  }
}